import { render, staticRenderFns } from "./Neighbour.vue?vue&type=template&id=042f901b&scoped=true"
import script from "./Neighbour.vue?vue&type=script&lang=js"
export * from "./Neighbour.vue?vue&type=script&lang=js"
import style0 from "./Neighbour.vue?vue&type=style&index=0&id=042f901b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "042f901b",
  null
  
)

export default component.exports